import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RapidReviewDiagnosisComponent } from '@shared/component/rapid-review-modal/rapid-review-diagnosis/rapid-review-diagnosis.component';
import {
	RapidReviewAcuityFieldFormattedResponse,
	RapidReviewHistoryFormattedResponse,
	RapidReviewModalService
} from '@shared/component/rapid-review-modal/rapid-review-modal.service';
import { GridUtil, RevColDef } from 'majora';
import { AgGridModule } from 'ag-grid-angular';
import { AgAutoFitColumnsDirective } from '@shared/directives/grid/ag-auto-fit-columns/ag-auto-fit-columns.directive';
import { AgGridNoFilteredRowsDirective, YesNoPipe } from 'morgana';
import { AgGridTooltipDirective } from '@shared/directives/grid/tooltip/ag-grid-tooltip.directive';

@Component({
	selector: 'pms-rapid-review-history',
	imports: [
		AgGridModule,
		AgAutoFitColumnsDirective,
		AgGridNoFilteredRowsDirective,
		AgGridTooltipDirective,
		YesNoPipe,
		RapidReviewDiagnosisComponent,
	],
	templateUrl: './rapid-review-history.component.html',
})
export class RapidReviewHistoryComponent implements OnInit {
	private rapidReviewModalService = inject(RapidReviewModalService);

	@Input({required: true})
	encounterId: number;

	@ViewChild('visualAcuityTemplate')
	visualAcuityTemplate!: TemplateRef<any>;

	history: RapidReviewHistoryFormattedResponse;
	gridColumns: RevColDef<RapidReviewAcuityFieldFormattedResponse>[] = [
		GridUtil.buildColumn('', 'fieldName', {sortable: false}),
		GridUtil.buildFieldTemplateColumn('Uncorrected Visual Acuity', 'uncorrected', () => this.visualAcuityTemplate, {sortable: false}),
		GridUtil.buildFieldTemplateColumn('Aided Visual Acuity', 'aided', () => this.visualAcuityTemplate, {flex: 1, sortable: false}),
	];

	ngOnInit(): void {
		this.rapidReviewModalService.getRapidReviewHistory(this.encounterId).subscribe(response => this.history = response);
	}
}
